const COOKIE = {
  LOGIN_REDIRECT: 'loginRedirect',
  SET_LOGIN_DATA: 'setLoginData',
}

export default COOKIE
